
    (function ($) {

        $.fn.vcDashboard = function (options) {

            var defaults = {
                id: null,
                name: "Dashboard",
                columns: 24,
                rows: 25,
                cellHeight: 80,
                height: null,
                width: null,
                readonly: false,

                LoggerId: null,
                LangId: 2,
                Signals: [],
                Status: null,
                startConfig: null,
                callback: function () { }
            };

            var settings = $.extend({}, defaults, options);

            vcDashboardResources.setLang(settings.LangId);

            return this.each(function () {
                var $element = $(this);

                // Dashboard-ID bestimmen
                var dashboardId = settings.id || $element.attr("id") || ("dashboard-" + Math.floor(Math.random() * 1000000));
                var sidebarId = "sidebar-" + dashboardId;

                // Höhe des Elements vor dem Bereinigen auslesen
                var elementHeight = $element.height();

                // Bereits initialisiert -> bereinigen
                if ($element.data("vcDashboard")) {
                    $element.find(".vc-dashboard-wrapper").remove();
                    $element.removeData("vcDashboard");
                }

                // Struktur innerhalb des Elements erzeugen ohne das Element selbst zu verändern
                $element.html("");
                var $wrapper = $("<div class='vc-dashboard-wrapper'></div>");
                var $dashboard = $("<div class='vc-dashboard'></div>");
                var $breadcrumb = $("<div class='vc-dashboard-breadcrumb'></div>");
                var $grid = $("<div class='vc-dashboard-grid dashboard-grid-edit'></div>");
                var $sidebarEl = $("<div id='" + sidebarId + "' class='vc-dashboard-sidebar'></div>");

                $dashboard.append($breadcrumb, $grid);
                $wrapper.append($sidebarEl, $dashboard);
                $element.append($wrapper);

                // Hintergrundbild als eigener Layer (dynamisch per Config)
                var currentBgUrl = "";
                var currentMedia = null;
                var $bgLayer = $("<div class='dashboard-bg-layer'></div>").css({
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundSize: "100% 100%",
                    backgroundPosition: "left top",
                    backgroundRepeat: "no-repeat",
                    pointerEvents: "none",
                    zIndex: 0
                });
                $grid.append($bgLayer);

                function setBackgroundImage(url) {
                    currentBgUrl = url || "";
                    if (currentBgUrl) {
                        $bgLayer.css("backgroundImage", "url('" + currentBgUrl + "')");
                    } else {
                        $bgLayer.css("backgroundImage", "none");
                    }
                }

                function trimMediaPath(path) {
                    if (!path) return "";
                    var idx = path.indexOf("img/");
                    return idx >= 0 ? path.substring(idx) : path;
                }

                function setMedia(mediaValues) {
                    currentMedia = mediaValues || null;
                    var mediaPath = (currentMedia && currentMedia.mediaPath) ? trimMediaPath(currentMedia.mediaPath) : "";
                    if (mediaPath) {
                        var dataUrl = getMediaDataUrl(mediaPath);
                        setBackgroundImage(dataUrl);
                    } else {
                        setBackgroundImage("");
                    }
                }

                // Höhe setzen - cellHeight dynamisch aus rows berechnen
                var rawHeight = settings.height || elementHeight || 500;
                var breadcrumbHeight = $breadcrumb.outerHeight(true) || 0;
                var availableHeight = rawHeight - breadcrumbHeight;
                settings.cellHeight = Math.floor(availableHeight / settings.rows);
                var gridHeight = settings.cellHeight * settings.rows;
                var dashboardHeight = gridHeight + breadcrumbHeight;
                $wrapper.css("height", dashboardHeight + "px");
                $grid.css("height", gridHeight + "px");
                if (settings.width) {
                    $wrapper.css("width", settings.width + "px");
                }

                // Placeholder-Element
                var $placeholder = $("<div class='dashboard-placeholder'></div>");
                $grid.append($placeholder);

                // Set CSS variables for grid lines
                $grid[0].style.setProperty("--grid-col-width", (100 / settings.columns) + "%");
                $grid[0].style.setProperty("--grid-row-height", settings.cellHeight + "px");

                // Hilfsfunktionen
                function getCellWidth() {
                    return $grid.width() / settings.columns;
                }

                function snapToGrid(x, y) {
                    var cellW = getCellWidth();
                    var col = Math.round(x / cellW);
                    var row = Math.round(y / settings.cellHeight);
                    return { col: Math.max(0, col), row: Math.max(0, row) };
                }

                function positionElement($el, col, row, w, h) {
                    var leftPct = (col / settings.columns) * 100;
                    var widthPct = (w / settings.columns) * 100;
                    var totalRows = settings.rows;
                    var topPct = (row / totalRows) * 100;
                    $el.css({
                        left: leftPct + "%",
                        top: topPct + "%",
                        width: widthPct + "%",
                        height: (h * settings.cellHeight) + "px"
                    });
                }

                function decodeHtmlEntities(value) {
                    if (!value) return "";
                    return $("<textarea>").html(value).text();
                }

                function repositionAllItems() {
                    $grid.find(".dashboard-item").each(function () {
                        var $item = $(this);
                        var col = parseInt($item.attr("data-col"));
                        var row = parseInt($item.attr("data-row"));
                        var w = parseInt($item.attr("data-w"));
                        var h = parseInt($item.attr("data-h"));
                        positionElement($item, col, row, w, h);
                    });
                }

                // Kollisionsprüfung: Überlappen sich zwei Bereiche?
                function itemsOverlap(col1, row1, w1, h1, col2, row2, w2, h2) {
                    return !(col1 + w1 <= col2 || col2 + w2 <= col1 || row1 + h1 <= row2 || row2 + h2 <= row1);
                }

                // Bestehende Items nach rechts verschieben wenn nötig
                function resolveCollisions($excludeItem, col, row, w, h) {
                    $grid.find(".dashboard-item").each(function () {
                        var $other = $(this);
                        if ($excludeItem && $other[0] === $excludeItem[0]) return;
                        if ($other.attr("data-allow-overlap") === "true") return;

                        var otherCol = parseInt($other.attr("data-col"));
                        var otherRow = parseInt($other.attr("data-row"));
                        var otherW = parseInt($other.attr("data-w"));
                        var otherH = parseInt($other.attr("data-h"));

                        if (itemsOverlap(col, row, w, h, otherCol, otherRow, otherW, otherH)) {
                            // Verschiebe das andere Item nach rechts
                            var newCol = col + w;
                            // Wenn es nicht mehr passt, in die nächste Zeile
                            if (newCol + otherW > settings.columns) {
                                newCol = 0;
                                var newRow = row + h;
                                $other.attr("data-col", newCol);
                                $other.attr("data-row", newRow);
                                positionElement($other, newCol, newRow, otherW, otherH);
                                resolveCollisions($other, newCol, newRow, otherW, otherH);
                            } else {
                                $other.attr("data-col", newCol);
                                positionElement($other, newCol, otherRow, otherW, otherH);
                                resolveCollisions($other, newCol, otherRow, otherW, otherH);
                            }
                        }
                    });
                }

                // Item zum Grid hinzufügen
                function addItem(itemData, col, row, options) {
                    var opts = options || {};
                    var itemSettings = itemData.settings || {};
                    var itemName = (itemData.name || "").trim();
                    var itemTitle = (itemData.title || "").trim();
                    var itemUnit = (itemData.unit || "").trim();
                    var tooltip = itemName || itemTitle;
                    if (itemUnit) tooltip += " [" + itemUnit + "]";
                    if (itemName && itemTitle) tooltip += " – " + itemTitle;
                    var $item = $("<div class='dashboard-item'></div>")
                        .attr("data-id", itemData.id)
                        .attr("data-type", itemData.type)
                        .attr("data-name", itemName)
                        .attr("data-col", col)
                        .attr("data-row", row)
                        .attr("data-w", itemData.w)
                        .attr("data-h", itemData.h)
                        .attr("data-allow-overlap", itemData.allowOverlap ? "true" : "false")
                        .attr("data-settings", JSON.stringify(itemSettings))
                        .attr("title", tooltip);

                    if (itemData.icon) $item.attr("data-icon", itemData.icon);
                    if (itemData.svgIcon) $item.attr("data-svg-icon", itemData.svgIcon);

                    // Background items always render behind other items
                    if (itemData.type === "background") {
                        $item.css("z-index", "0");
                    } else {
                        $item.css("z-index", "1");
                    }

                    var $content = $("<div class='dashboard-item-content'>" + itemData.title + "</div>");
                    $item.append($content);

                    // Plugin defaults for resizable/copyable
                    var plugin = vcDashboardRegistry.get(itemData.type);
                    var pluginDefaults = (plugin && plugin.defaults) || {};
                    var isResizable = pluginDefaults.resizable !== false;
                    var isCopyable = pluginDefaults.copyable !== false;

                    if (isResizable) {
                        $item.append(
                            "<div class='resize-handle resize-handle-tl'></div>" +
                            "<div class='resize-handle resize-handle-tr'></div>" +
                            "<div class='resize-handle resize-handle-bl'></div>" +
                            "<div class='resize-handle resize-handle-br'></div>"
                        );
                    }

                    // Kopieren-Icon
                    if (isCopyable) {
                        var $copyBtn = $("<div class='dashboard-copy-btn'><i class='fa-solid fa-clone color-font-secondary'></i></div>");
                        $item.append($copyBtn);
                        $copyBtn.on("click", function (e) {
                            e.stopPropagation();
                            pushUndo();
                            var srcCol = parseInt($item.attr("data-col"));
                            var srcRow = parseInt($item.attr("data-row"));
                            var srcW = parseInt($item.attr("data-w"));
                            var srcH = parseInt($item.attr("data-h"));
                            var newCol = srcCol + srcW;
                            if (newCol + srcW > settings.columns) {
                                newCol = 0;
                                srcRow = srcRow + srcH;
                            }
                            var currentSettings = {};
                            try { currentSettings = JSON.parse($item.attr("data-settings") || "{}"); } catch (ex) { }
                            var copyData = $.extend(true, {}, itemData, { w: srcW, h: srcH, settings: currentSettings });
                            if (copyData.type === "subdashboard") {
                                var uniqueSubId = "sub-" + Date.now() + "-" + Math.floor(Math.random() * 10000);
                                copyData.settings = $.extend({}, copyData.settings, { subId: uniqueSubId });
                            }
                            addItem(copyData, newCol, srcRow, { resolveCollisions: true, save: true, openSettings: true });
                        });
                    }

                    positionElement($item, col, row, itemData.w, itemData.h);
                    $grid.append($item);

                    // Plugin rendern
                    if (vcDashboardRegistry && vcDashboardRegistry.hasType(itemData.type)) {
                        vcDashboardRegistry.render(itemData.type, $content, itemData);
                    }

                    // Init-Funktion des Plugins aufrufen
                    if (plugin && typeof plugin.init === "function") {
                        plugin.init($item, itemSettings);
                    }

                    // Post-creation: Kollisionen auflösen, speichern, Settings öffnen
                    if (opts.resolveCollisions && plugin && plugin.defaults && plugin.defaults.pushOthers) {
                        resolveCollisions($item, col, row, itemData.w, itemData.h);
                    }
                    if (opts.save) {
                        saveConfig();
                    }
                    if (opts.openSettings && plugin && plugin.defaults && plugin.defaults.openSettingsOnCreate) {
                        $item.find(".dashboard-settings-btn").trigger("click");
                    }

                    // Drag auf Grid-Items
                    interact($item[0]).draggable({
                        inertia: false,
                        autoScroll: false,
                        listeners: {
                            start: function (event) {
                                pushUndo();
                                $(event.target).addClass("dragging");
                                $placeholder.show();
                            },
                            move: function (event) {
                                var target = event.target;
                                var x = (parseFloat(target.getAttribute("data-drag-x")) || 0) + event.dx;
                                var y = (parseFloat(target.getAttribute("data-drag-y")) || 0) + event.dy;
                                target.style.transform = "translate(" + x + "px, " + y + "px)";
                                target.setAttribute("data-drag-x", x);
                                target.setAttribute("data-drag-y", y);

                                // Placeholder anzeigen
                                var gridRect = $grid[0].getBoundingClientRect();
                                var targetRect = target.getBoundingClientRect();
                                var relX = targetRect.left - gridRect.left;
                                var relY = targetRect.top - gridRect.top;
                                var snap = snapToGrid(relX, relY);
                                var w = parseInt(target.getAttribute("data-w"));
                                var h = parseInt(target.getAttribute("data-h"));
                                snap.col = Math.min(snap.col, settings.columns - w);
                                positionElement($placeholder, snap.col, snap.row, w, h);

                                // Papierkorb hervorheben
                                if (isOverTrash(event)) {
                                    $trash.addClass("active");
                                } else {
                                    $trash.removeClass("active");
                                }
                            },
                            end: function (event) {
                                var target = event.target;
                                var $t = $(target);
                                $t.removeClass("dragging");
                                $placeholder.hide();
                                $trash.removeClass("active");

                                // Papierkorb: Item entfernen
                                if (isOverTrash(event)) {
                                    cleanupRemovedItem($t);
                                    interact(target).unset();
                                    $t.remove();
                                    saveConfig();
                                    return;
                                }

                                var x = parseFloat(target.getAttribute("data-drag-x")) || 0;
                                var y = parseFloat(target.getAttribute("data-drag-y")) || 0;
                                var gridRect = $grid[0].getBoundingClientRect();
                                var targetRect = target.getBoundingClientRect();
                                var relX = targetRect.left - gridRect.left;
                                var relY = targetRect.top - gridRect.top;
                                var snap = snapToGrid(relX, relY);
                                var w = parseInt(target.getAttribute("data-w"));
                                var h = parseInt(target.getAttribute("data-h"));
                                snap.col = Math.min(snap.col, settings.columns - w);

                                target.style.transform = "";
                                target.setAttribute("data-drag-x", 0);
                                target.setAttribute("data-drag-y", 0);
                                target.setAttribute("data-col", snap.col);
                                target.setAttribute("data-row", snap.row);
                                positionElement($t, snap.col, snap.row, w, h);

                                var dragPlugin = vcDashboardRegistry.get($t.attr("data-type"));
                                if (dragPlugin && dragPlugin.defaults && dragPlugin.defaults.pushOthers) {
                                    resolveCollisions($t, snap.col, snap.row, w, h);
                                }

                                saveConfig();
                            }
                        }
                    });

                    // Resize auf Grid-Items
                    if (isResizable) {
                        interact($item[0]).resizable({
                            edges: {
                                top: '.resize-handle-tl, .resize-handle-tr',
                                left: '.resize-handle-tl, .resize-handle-bl',
                                bottom: '.resize-handle-bl, .resize-handle-br',
                                right: '.resize-handle-tr, .resize-handle-br'
                            },
                            listeners: {
                                start: function (event) {
                                    var target = event.target;
                                    var $target = $(target);
                                    var $overlay = $("<div class='dashboard-resize-overlay'></div>");
                                    $target.append($overlay);
                                    var w = parseInt(target.getAttribute("data-w"));
                                    var h = parseInt(target.getAttribute("data-h"));
                                    $overlay.text(w + " × " + h);
                                    target.setAttribute("data-orig-col", target.getAttribute("data-col"));
                                    target.setAttribute("data-orig-row", target.getAttribute("data-row"));
                                    target.setAttribute("data-orig-w", w);
                                    target.setAttribute("data-orig-h", h);
                                },
                                move: function (event) {
                                    var target = event.target;
                                    var cellW = getCellWidth();
                                    var origCol = parseInt(target.getAttribute("data-orig-col"));
                                    var origRow = parseInt(target.getAttribute("data-orig-row"));
                                    var origW = parseInt(target.getAttribute("data-orig-w"));
                                    var origH = parseInt(target.getAttribute("data-orig-h"));
                                    var totalRows = settings.rows;

                                    var newW = Math.max(1, Math.round(event.rect.width / cellW));
                                    var newH = Math.max(1, Math.round(event.rect.height / settings.cellHeight));

                                    var colDelta = origW - newW;
                                    var rowDelta = origH - newH;

                                    var edges = event.edges || {};
                                    var newCol = edges.left ? Math.max(0, origCol + colDelta) : origCol;
                                    var newRow = edges.top ? Math.max(0, origRow + rowDelta) : origRow;

                                    if (edges.left) newW = Math.min(newW, origCol + origW);
                                    if (edges.right) newW = Math.min(newW, settings.columns - origCol);
                                    if (edges.top) newH = Math.min(newH, origRow + origH);
                                    if (edges.bottom) newH = Math.min(newH, totalRows - origRow);

                                    var tx = (newCol - origCol) * cellW;
                                    var ty = (newRow - origRow) * settings.cellHeight;
                                    target.style.transform = "translate(" + tx + "px, " + ty + "px)";
                                    target.style.width = newW * cellW + "px";
                                    target.style.height = newH * settings.cellHeight + "px";
                                    $(target).find(".dashboard-resize-overlay").text(newW + " × " + newH);
                                },
                                end: function (event) {
                                    $(event.target).find(".dashboard-resize-overlay").remove();
                                    var target = event.target;
                                    var $target = $(target);
                                    var cellW = getCellWidth();
                                    var totalRows = settings.rows;

                                    var origCol = parseInt(target.getAttribute("data-orig-col"));
                                    var origRow = parseInt(target.getAttribute("data-orig-row"));
                                    var origW = parseInt(target.getAttribute("data-orig-w"));
                                    var origH = parseInt(target.getAttribute("data-orig-h"));

                                    var newW = Math.max(1, Math.round(event.rect.width / cellW));
                                    var newH = Math.max(1, Math.round(event.rect.height / settings.cellHeight));

                                    var edges = event.edges || {};
                                    var colDelta = origW - newW;
                                    var rowDelta = origH - newH;
                                    var newCol = edges.left ? Math.max(0, origCol + colDelta) : origCol;
                                    var newRow = edges.top ? Math.max(0, origRow + rowDelta) : origRow;

                                    if (edges.left) newW = Math.min(newW, origCol + origW);
                                    if (edges.right) newW = Math.min(newW, settings.columns - origCol);
                                    if (edges.top) newH = Math.min(newH, origRow + origH);
                                    if (edges.bottom) newH = Math.min(newH, totalRows - origRow);
                                    newW = Math.max(1, newW);
                                    newH = Math.max(1, newH);

                                    target.style.transform = "";
                                    target.removeAttribute("data-orig-col");
                                    target.removeAttribute("data-orig-row");
                                    target.removeAttribute("data-orig-w");
                                    target.removeAttribute("data-orig-h");
                                    target.setAttribute("data-col", newCol);
                                    target.setAttribute("data-row", newRow);
                                    target.setAttribute("data-w", newW);
                                    target.setAttribute("data-h", newH);
                                    positionElement($target, newCol, newRow, newW, newH);

                                    var type = $target.attr("data-type");
                                    var plugin = vcDashboardRegistry.get(type);
                                    if (plugin && typeof plugin.resize === "function") {
                                        var itemSettings = JSON.parse($target.attr("data-settings") || "{}");
                                        plugin.resize($target, itemSettings);
                                    }
                                    saveConfig();
                                }
                            }
                        });
                    }

                    return $item;
                }

                // Build combined item list: static vcDashboardItems + dynamic signal-based items
                var allItems = (typeof vcDashboardItems !== "undefined") ? vcDashboardItems.slice() : [];
                var signalsList = settings.signals || settings.Signals || [];
                allItems.push({
                    id: "online-generic",
                    name: vcDashboardResources.get("onlineValues"),
                    title: "",
                    type: "online",
                    allowOverlap: true,
                    settings: { LoggerId: settings.LoggerId || 1 }
                });
                allItems.push({
                    id: "simplesignal-generic",
                    name: vcDashboardResources.get("singleValue"),
                    title: "",
                    type: "simplesignal",
                    allowOverlap: false,
                    settings: { LoggerId: settings.LoggerId || 1 }
                });

                // Apply plugin defaults (w, h) and inject LoggerId and Day into all items
                var statusDay = (settings.Status && settings.Status.date) ? settings.Status.date.singleDate : null;
                $.each(allItems, function (i, item) {
                    var plugin = vcDashboardRegistry.get(item.type);
                    if (plugin && plugin.defaults) {
                        if (!item.w) item.w = plugin.defaults.w;
                        if (!item.h) item.h = plugin.defaults.h;
                    }
                    if (item.settings && settings.LoggerId && !item.settings.LoggerId) {
                        item.settings.LoggerId = settings.LoggerId;
                    }
                    if (item.settings && statusDay) {
                        item.settings.Day = statusDay;
                    }
                });

                // Sidebar rendern (via dashboard-menu.js)
                var menuResult = vcDashboardMenu.build({
                    allItems: allItems,
                    settings: settings,
                    $sidebar: $sidebarEl,
                    $grid: $grid,
                    $placeholder: $placeholder,
                    pushUndo: pushUndo,
                    snapToGrid: snapToGrid,
                    positionElement: positionElement,
                    addItem: addItem,
                    resolveCollisions: resolveCollisions,
                    saveConfig: saveConfig,
                    setMedia: setMedia
                });
                var $trash = menuResult.$trash;
                var $mediaName = menuResult.$mediaName;
                var $mediaPath = menuResult.$mediaPath;
                function isOverTrash(event) { return menuResult.isOverTrash(event); }

                // Undo-History
                var undoStack = [];

                function pushUndo() {
                    undoStack.push(getCurrentConfig());
                }

                // In-memory store for sub-dashboard configs
                var subConfigs = {};

                // Recursively remove subConfigs for a given subId and all its nested children
                function removeSubConfigs(subId) {
                    var conf = subConfigs[subId];
                    if (conf && conf.items) {
                        $.each(conf.items, function (i, item) {
                            if (item.type === "subdashboard" && item.settings && item.settings.subId) {
                                removeSubConfigs(item.settings.subId);
                            }
                        });
                    }
                    delete subConfigs[subId];
                }

                // Remove subConfigs for a dashboard item (if it is a subdashboard)
                function cleanupRemovedItem($item) {
                    if ($item.attr("data-type") === "subdashboard") {
                        var itemSettings = {};
                        try { itemSettings = JSON.parse($item.attr("data-settings") || "{}"); } catch (ex) { }
                        if (itemSettings.subId) {
                            removeSubConfigs(itemSettings.subId);
                        }
                    }
                }

                // Autosave: aktuellen Zustand speichern (relativ zur Grid-Größe)
                function saveConfig() {
                    var config = getCurrentConfig();
                    var currentSubId = getCurrentSubId();
                    subConfigs[currentSubId] = config;
                    if (typeof settings.callback === "function") {
                        var fullConfig = { root: subConfigs["root"] || config, subConfigs: $.extend({}, subConfigs) };
                        settings.callback.call($element, fullConfig);
                    }
                    updateLayerMenu();
                }

                function getCurrentConfig() {
                    var items = [];
                    var gridW = $grid.width();
                    var gridH = $grid.height();
                    $grid.find(".dashboard-item").each(function () {
                        var $item = $(this);
                        var left = parseFloat($item.css("left"));
                        var top = parseFloat($item.css("top"));
                        var width = parseFloat($item.css("width"));
                        var height = parseFloat($item.css("height"));
                        var itemSettings = {};
                        try { itemSettings = JSON.parse($item.attr("data-settings") || "{}"); } catch (e) { }
                        items.push({
                            id: $item.attr("data-id"),
                            type: $item.attr("data-type"),
                            name: $item.attr("data-name") || "",
                            xPct: left / gridW,
                            yPct: top / gridH,
                            wPct: width / gridW,
                            hPct: height / gridH,
                            col: parseInt($item.attr("data-col")),
                            row: parseInt($item.attr("data-row")),
                            w: parseInt($item.attr("data-w")),
                            h: parseInt($item.attr("data-h")),
                            settings: itemSettings
                        });
                    });
                    return { columns: settings.columns, cellHeight: settings.cellHeight, gridW: gridW, gridH: gridH, items: items, media: currentMedia };
                }

                function undo() {
                    if (undoStack.length === 0) return;
                    var prevConfig = undoStack.pop();
                    // Grid leeren und vorherigen Zustand wiederherstellen
                    $grid.find(".dashboard-item").each(function () {
                        interact(this).unset();
                    });
                    $grid.find(".dashboard-item").remove();
                    restoreItems(prevConfig);
                    subConfigs[getCurrentSubId()] = prevConfig;
                }

                // Autoload: Config beim Start laden
                function loadConfig() {
                    if (settings.startConfig) {
                        var raw = (typeof settings.startConfig === "string") ? JSON.parse(settings.startConfig) : settings.startConfig;
                        // Support full config format with subConfigs
                        if (raw.root && raw.subConfigs) {
                            subConfigs = raw.subConfigs;
                            restoreItems(raw.root);
                        } else {
                            restoreItems(raw);
                        }
                    }
                }

                function restoreItems(config) {
                    currentMedia = config.media || null;
                    if ($mediaName) $mediaName.text(currentMedia ? currentMedia.mediaName || "" : "");
                    if ($mediaPath) $mediaPath.val(currentMedia ? currentMedia.mediaPath || "" : "");
                    var mediaPath = (currentMedia && currentMedia.mediaPath) ? trimMediaPath(currentMedia.mediaPath) : "";
                    if (mediaPath) {
                        var dataUrl = getMediaDataUrl(mediaPath);
                        setBackgroundImage(dataUrl);
                    } else {
                        setBackgroundImage("");
                    }
                    $.each(config.items, function (i, saved) {
                        var itemData = null;
                        $.each(allItems, function (j, d) {
                            if (d.id === saved.id) { itemData = d; return false; }
                        });
                        // Backward compat: old per-signal items (signal-*) map to generic online item
                        if (!itemData && saved.type === "online") {
                            $.each(allItems, function (j, d) {
                                if (d.id === "online-generic") { itemData = d; return false; }
                            });
                        }
                        // Fallback: reconstruct item from saved data if plugin is registered
                        if (!itemData && saved.type && vcDashboardRegistry.hasType(saved.type)) {
                            var plugin = vcDashboardRegistry.get(saved.type);
                            var pDefaults = (plugin && plugin.defaults) || {};
                            itemData = {
                                id: saved.id,
                                type: saved.type,
                                name: saved.name || "",
                                title: "",
                                w: saved.w || pDefaults.w || 4,
                                h: saved.h || pDefaults.h || 4,
                                allowOverlap: false,
                                settings: saved.settings || {}
                            };
                        }
                        if (itemData) {
                            var col = saved.col || 0;
                            var row = saved.row || 0;
                            var w = saved.w;
                            var h = saved.h;
                            var mergedSettings = saved.settings || itemData.settings || {};
                            var mergedName = saved.name || itemData.name || "";
                            var merged = $.extend({}, itemData, { w: w, h: h, settings: mergedSettings, name: mergedName });
                            addItem(merged, col, row);
                        }
                    });
                }

                // Subdashboard Navigation
                var navigationStack = [{ subId: "root", title: decodeHtmlEntities(settings.name) }];

                // Layer menu icon + dropdown
                var $layerBtn = $("<span class='dashboard-layer-btn dashboard-layer-btn-disabled' title='Layers'><i class='fa-solid fa-layer-group'></i></span>");
                var $layerDropdown = $("<div class='dashboard-layer-dropdown'></div>");
                $layerBtn.append($layerDropdown);
                $breadcrumb.append($layerBtn);

                $layerBtn.on("click", function (e) {
                    e.stopPropagation();
                    if ($layerBtn.hasClass("dashboard-layer-btn-disabled")) return;
                    $layerDropdown.toggle();
                });
                $(document).on("click", function () {
                    $layerDropdown.hide();
                });
                $layerDropdown.on("click", function (e) {
                    e.stopPropagation();
                });

                function updateLayerMenu() {
                    var keys = Object.keys(subConfigs);
                    $.each(navigationStack, function (i, entry) {
                        if (keys.indexOf(entry.subId) === -1) keys.push(entry.subId);
                    });
                    if (keys.length <= 1) {
                        $layerBtn.addClass("dashboard-layer-btn-disabled");
                        $layerDropdown.hide();
                        return;
                    }
                    $layerBtn.removeClass("dashboard-layer-btn-disabled");
                    $layerDropdown.empty();

                    // Build tree: find children (subdashboard items) for each layer
                    function getChildLayers(parentSubId) {
                        var children = [];
                        var conf = subConfigs[parentSubId];
                        if (conf && conf.items) {
                            $.each(conf.items, function (ii, saved) {
                                if (saved.type === "subdashboard" && saved.settings && saved.settings.subId) {
                                    var childId = saved.settings.subId;
                                    var childName = decodeHtmlEntities(saved.name || "");
                                    if (!childName) return;
                                    children.push({ subId: childId, name: childName });
                                }
                            });
                        }
                        return children;
                    }

                    function findPathToLayer(targetSubId) {
                        // BFS/DFS to find path from root to targetSubId
                        var path = [{ subId: "root", name: navigationStack[0].title }];
                        function search(parentSubId, currentPath) {
                            var children = getChildLayers(parentSubId);
                            for (var i = 0; i < children.length; i++) {
                                var child = children[i];
                                var newPath = currentPath.concat([child]);
                                if (child.subId === targetSubId) return newPath;
                                var result = search(child.subId, newPath);
                                if (result) return result;
                            }
                            return null;
                        }
                        if (targetSubId === "root") return path;
                        var result = search("root", path);
                        return result || path.concat([{ subId: targetSubId, name: targetSubId }]);
                    }

                    function navigateToLayer(targetSubId, targetName) {
                        // Save current state
                        subConfigs[getCurrentSubId()] = getCurrentConfig();

                        // Build full path and set navigation stack
                        var path = findPathToLayer(targetSubId);
                        navigationStack = [];
                        $.each(path, function (i, entry) {
                            navigationStack.push({ subId: entry.subId, title: entry.name });
                        });
                        undoStack = [];
                        renderBreadcrumb();

                        // Clear and load target
                        clearGrid();
                        var subConfig = subConfigs[targetSubId];
                        if (subConfig) {
                            restoreItems(subConfig);
                        } else if (targetSubId === "root") {
                            loadConfig();
                        }
                    }

                    function renderTreeLevel($container, parentSubId, depth) {
                        var children = getChildLayers(parentSubId);
                        $.each(children, function (i, child) {
                            var $item = $("<div class='dashboard-layer-dropdown-item'></div>")
                                .css("padding-left", (12 + depth * 16) + "px")
                                .text(child.name);
                            if (child.subId === getCurrentSubId()) {
                                $item.addClass("active");
                            }
                            $item.on("click", function () {
                                $layerDropdown.hide();
                                navigateToLayer(child.subId, child.name);
                            });
                            $container.append($item);
                            // Recurse into children
                            renderTreeLevel($container, child.subId, depth + 1);
                        });
                    }

                    // Root entry
                    var rootEntry = navigationStack[0];
                    var $rootItem = $("<div class='dashboard-layer-dropdown-item'></div>").text(rootEntry.title);
                    if (rootEntry.subId === getCurrentSubId()) {
                        $rootItem.addClass("active");
                    }
                    $rootItem.on("click", function () {
                        $layerDropdown.hide();
                        navigateToLayer("root", rootEntry.title);
                    });
                    $layerDropdown.append($rootItem);

                    // Render tree starting from root
                    renderTreeLevel($layerDropdown, "root", 1);
                }

                function renderBreadcrumb() {
                    $breadcrumb.find(".vc-dashboard-breadcrumb-sep, .vc-dashboard-breadcrumb-item").remove();
                    var $undoBtnEl = $breadcrumb.find(".dashboard-undo-btn");
                    $.each(navigationStack, function (i, entry) {
                        if (i > 0) {
                            var $sep = $("<span class='vc-dashboard-breadcrumb-sep'><i class='fa-solid fa-chevron-right'></i></span>");
                            if ($undoBtnEl.length) $undoBtnEl.before($sep); else $breadcrumb.append($sep);
                        }
                        var $crumb = $("<span class='vc-dashboard-breadcrumb-item'></span>").text(entry.title);
                        if (i < navigationStack.length - 1) {
                            $crumb.addClass("vc-dashboard-breadcrumb-link");
                            $crumb.attr("data-nav-index", i);
                            $crumb.on("click", function () {
                                var targetIndex = parseInt($(this).attr("data-nav-index"));
                                navigateToIndex(targetIndex);
                            });
                        } else {
                            $crumb.addClass("vc-dashboard-breadcrumb-current");
                        }
                        if ($undoBtnEl.length) $undoBtnEl.before($crumb); else $breadcrumb.append($crumb);
                    });
                    updateLayerMenu();
                }

                function clearGrid() {
                    $grid.find(".dashboard-item").each(function () {
                        interact(this).unset();
                    });
                    $grid.find(".dashboard-item").remove();
                    setBackgroundImage("");
                }

                function getCurrentSubId() {
                    return navigationStack[navigationStack.length - 1].subId;
                }

                function navigateTo(subId, title) {
                    // Save current dashboard state in memory
                    var currentSubId = getCurrentSubId();
                    subConfigs[currentSubId] = getCurrentConfig();

                    // Push new level, reset undo for new context
                    navigationStack.push({ subId: subId, title: decodeHtmlEntities(title || subId) });
                    undoStack = [];
                    renderBreadcrumb();

                    // Clear and load sub-dashboard
                    clearGrid();
                    var subConfig = subConfigs[subId];
                    if (subConfig) {
                        restoreItems(subConfig);
                    }
                }

                function navigateToIndex(targetIndex) {
                    // Save current state in memory
                    subConfigs[getCurrentSubId()] = getCurrentConfig();

                    // Pop stack to target, reset undo for new context
                    navigationStack = navigationStack.slice(0, targetIndex + 1);
                    undoStack = [];
                    renderBreadcrumb();

                    // Clear and load target dashboard
                    clearGrid();
                    var targetSubId = getCurrentSubId();
                    var subConfig = subConfigs[targetSubId];
                    if (subConfig) {
                        restoreItems(subConfig);
                    } else if (targetSubId === "root") {
                        loadConfig();
                    }
                }

                renderBreadcrumb();

                // Readonly-Modus
                var isReadonly = false;
                var isLockedByOption = settings.readonly === true;

                if (!isLockedByOption) {
                    var $undoBtn = $("<button type='button' class='dashboard-undo-btn'><i class='fa-solid fa-rotate-left'></i></button>");
                    var $closeBtn = $("<div class='button-toggle dashboard-close-btn'>" + vcDashboardResources.get("close") + "</div>");
                    $breadcrumb.append($undoBtn);
                    $breadcrumb.append($closeBtn);
                    $closeBtn.button();

                    $undoBtn.on("click", function () {
                        undo();
                    });

                    $closeBtn.on("click", function () {
                        $("body").trigger({ type: "Trigger-vcDashboard-Close", value: { dashboardId: dashboardId } });
                    });
                }

                function setReadonly(readonly, skipResize) {
                    isReadonly = readonly;
                    if (isReadonly) {
                        $grid.removeClass("dashboard-grid-edit");
                        $sidebarEl.hide();
                        $grid.find(".dashboard-item").each(function () {
                            interact(this).draggable(false);
                            interact(this).resizable(false);
                        });
                        $grid.find(".resize-handle").hide();
                        $grid.find(".dashboard-copy-btn").hide();
                        $grid.find(".dashboard-settings-btn").hide();
                        $dashboard.find(".dashboard-undo-btn").hide();
                        $dashboard.find(".dashboard-close-btn").hide();
                    } else {
                        $grid.addClass("dashboard-grid-edit");
                        $sidebarEl.show();
                        $grid.find(".dashboard-item").each(function () {
                            interact(this).draggable(true);
                            interact(this).resizable(true);
                        });
                        $grid.find(".resize-handle").show();
                        $grid.find(".dashboard-copy-btn").show();
                        $grid.find(".dashboard-settings-btn").show();
                        $dashboard.find(".dashboard-undo-btn").show();
                        $dashboard.find(".dashboard-close-btn").show();
                    }

                    // Re-init all items after layout change
                    repositionAllItems();
                    if (!skipResize) {
                        setTimeout(function () {
                            $grid.find(".dashboard-item").each(function () {
                                var $item = $(this);
                                var type = $item.attr("data-type");
                                var plugin = vcDashboardRegistry.get(type);
                                if (plugin && typeof plugin.resize === "function") {
                                    var itemSettings = JSON.parse($item.attr("data-settings") || "{}");
                                    plugin.resize($item, itemSettings);
                                }
                            });
                        }, 0);
                    }
                }

                // API am Element speichern (vor loadConfig, damit Plugins beim Init darauf zugreifen können)
                $element.data("vcDashboard", {
                    addItem: addItem,
                    saveConfig: saveConfig,
                    loadConfig: loadConfig,
                    setReadonly: setReadonly,
                    undo: undo,
                    navigateTo: navigateTo,
                    navigateBack: function () { if (navigationStack.length > 1) navigateToIndex(navigationStack.length - 2); },
                    getSettings: function () { return settings; },
                    getSignals: function () { return settings.Signals || []; },
                    getItems: function () { return getCurrentConfig().items; },
                    updateStatus: function (newStatus) {
                        settings.Status = newStatus;
                        var statusDay = (newStatus && newStatus.date) ? newStatus.date.singleDate : null;
                        $grid.find(".dashboard-item").each(function () {
                            var $item = $(this);
                            var type = $item.attr("data-type");
                            var itemSettings = {};
                            try { itemSettings = JSON.parse($item.attr("data-settings") || "{}"); } catch (ex) { }
                            if (statusDay) {
                                itemSettings.Day = statusDay;
                                $item.attr("data-settings", JSON.stringify(itemSettings));
                            }
                            var plugin = vcDashboardRegistry.get(type);
                            if (plugin && typeof plugin.onLoad === "function") {
                                plugin.onLoad($item, itemSettings);
                            }
                        });
                    }
                });

                loadConfig();
                updateLayerMenu();

                if (isLockedByOption) {
                    setReadonly(true, false);
                }


            });
        };

    })(jQuery);